import { useContext, useState } from 'react'

import { BlockforceIcon } from '../../assets/icons'
import { AuthContext } from '../../contexts/auth'
import { Modal } from '../Modal'
import { TermsAndConditions } from '../TermsAndConditions'

import styles from './styles.module.scss'

export const Footer = () => {
  const { user } = useContext(AuthContext)
  const [open, setOpen] = useState(false)

  return (
    <div className={styles.footer}>
      {user && (
        <p className={styles.terms} onClick={() => setOpen(true)}>
          Política de Privacidade e Uso de Dados
        </p>
      )}
      <BlockforceIcon color="3A3A3A" size="36px" />
      <p>© Copyright 2022</p>
      <Modal
        title={'Política de Privacidade e Uso de Dados'}
        open={open}
        onClose={() => setOpen(false)}
        content={
          <div className={styles.modal}>
            <TermsAndConditions />
          </div>
        }
      ></Modal>
    </div>
  )
}
